import { useRequiredContext } from "@redotech/react-util/context";
import MessageSquareIcon from "@redotech/redo-icons/message-square-01.svg";
import MessageSquareIconFilled from "@redotech/redo-icons/message-square-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { SecondaryNavigationData } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav";
import {
  RedoSecondaryNavItem,
  useNavTreeNode,
} from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export function useMessagingNavigation(): PageNavigationEntry | null {
  const team = useRequiredContext(TeamContext);
  const routes = useRequiredContext(MerchantRoutesContext);

  const isEnabled = team.settings.shopperAgent?.enabled;

  if (!isEnabled) {
    return null;
  }

  const primaryTab: LinkPrimaryTab = {
    id: "messaging",
    UnfilledIcon: MessageSquareIcon,
    FilledIcon: MessageSquareIconFilled,
    type: "link",
    pathRoot: routes.messagingBaseUrl,
    href: routes.messagingHref,
    friendlyName: "Messaging",
    hasNotification: false,
  };

  const secondaryNavigationData: SecondaryNavigationData = {
    id: "messaging",
    name: "Messaging",
    NavContent: SecondaryMessagingSection,
  };

  return { primaryTab, secondaryNavigationData };
}

const SecondaryMessagingSection = memo(function SecondaryMessagingSection() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { id: nodeId, TreeContext } = useNavTreeNode({
    friendlyName: "Messaging",
  });

  return (
    <TreeContext.Provider value={nodeId}>
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getMessagingSubRoute("conversations"),
        }}
        friendlyName="Conversations"
        id="messaging-conversations"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getMessagingSubRoute("pre-purchase"),
        }}
        friendlyName="Pre-Purchase Agent"
        id="messaging-pre-purchase"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getMessagingSubRoute("post-purchase"),
        }}
        friendlyName="Post-Purchase Agent"
        id="messaging-post-purchase"
      />
    </TreeContext.Provider>
  );
});
